import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPinboardComponent } from './simple-icons-pinboard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPinboardComponent ],
    exports:      [ SimpleIconsPinboardComponent ],
    bootstrap:    []
})
export class SimpleIconsPinboardModule {}
